export default __webpack_public_path__ + "static/media/acxiom.bae71f35.svg";